import axiosInstance from "./axiosInstance";
import getStoredUserInfo from "../helpers/getUserInfo";

const getUserProfile = async () => {
  const userInfo = getStoredUserInfo();
  const accessToken = userInfo?.token;

  if (!accessToken) {
    return null;
  }

  try {
    const response = await axiosInstance.get(`/getUserProfile`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      validateStatus: () => true,
    });

    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch {
    return null;
  }
};

export default getUserProfile;
